import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./SupermarketProductContainer.module.scss";
import { faImages, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import {
  AddRestaurantProductsPostApi,
  getBrandsApi,
  getSupermarketCategoryApi,
} from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { useForm } from "react-hook-form";

const SupermarketProductContainer = () => {
  const [supermarketCategory, setSupermarketCategory] = useState([]);
  const [value] = useState();
  const [chooseCategory, setChooseCategory] = useState();
  const [brandPersian, setBrandPersian] = useState();
  const [files, setFiles] = useState([]);
  const [isBigImg, setIsBigImg] = useState(false);
  const [imgName, setImgName] = useState();
  const [onChangeCat1, setOnChangeCat1] = useState(false);
  const [categoryId, setcategoryId] = useState();
  const [category2Id, setcategory2Id] = useState();
  const [brands, setBrands] = useState([]);
  const [disableCategorySecond, setDisableCategorySecond] = useState(true);
  const [disable, setDisable] = useState(false);
  const [, setChooseBrand] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getCategory();
    getBrandList();
  }, []);
  const getCategory = async () => {
    getSupermarketCategoryApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSupermarketCategory(res.category);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  let options =
    supermarketCategory &&
    supermarketCategory.map((item) => {
      return { value: item.id, label: item.category };
    });
  const getCategory1OnChange = (e) => {
    setOnChangeCat1(true);
    setcategoryId(e.value);
    setDisableCategorySecond(false);
  };
  ////////////category ///////////////
  let categoryOption =
    supermarketCategory &&
    supermarketCategory.map((item) => {
      return { value: item.id, label: item.category, parent: item.parent };
    });
  let categoryFirst = [];
  categoryOption.forEach((val) => {
    if (val.parent === "2") {
      categoryFirst.push(val);
    }
  });
  let categorySecond = [];
  categoryOption.forEach((val) => {
    if (val.parent === categoryId) {
      categorySecond.push(val);
    } else if (onChangeCat1 === false && val.value === category2Id) {
      setcategoryId(val.parent);
    }
  });
  const getCategory2OnChange = (e) => {
    setcategory2Id(e.value);
  };
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };
  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };
  const onSubmit = (data) => {
    setDisable(true);
    const info = {
      category: parseInt(category2Id),
      file: files,
      name: data.product,
      barcode_1: data.barcode1 === "" ? 0 : parseInt(data.barcode1),
      barcode_2: data.barcode2 === "" ? 0 : parseInt(data.barcode2),
      barcode_3: data.barcode3 === "" ? 0 : parseInt(data.barcode3),
      weight: data.weight === "" ? 0 : parseInt(data.weight),
      volume: data.volume === "" ? 0 : parseInt(data.volume),
      brand_id: parseInt(brandPersian),
      supplier_id: "",
    };
    AddRestaurantProductsPostApi(info, (res) => {
      if (res.status === 0) {
        errorToast(res.message);
        setDisable(false);
      } else {
        succToast(res.message);
        setDisable(false);
        // window.location.reload()
      }
    });
  };
  ///////////////نمایش بزرگتر عکس
  const showBigPic = (img) => {
    setIsBigImg(true);
    setImgName(img);
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const newList = files.filter((item) => item !== name);
    setFiles(newList);
  };
  const getBrandOnChange = (e) => {
    setChooseBrand(e.value);
    setBrandPersian(e.value);
  };
  ////////////brand ///////////////

  const getBrandList = async () => {
    getBrandsApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setBrands(res.brand);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  let brandOption =
    brands &&
    brands.map((item) => {
      return { value: item.id, label: item.brand_persian };
    });
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ثبت کالا فروشگاهی"} />
      {isBigImg ? (
        <div className={Style.bigImg} onClick={() => setIsBigImg(false)}>
          <img src={`${imgName}`} alt="" />
        </div>
      ) : null}
      <form onSubmit={handleSubmit(onSubmit)} className={Style.FormAddProduct}>
        <div className={Style.imagePart}>
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div
                  className={Style.picHolder}
                  onClick={() => showBigPic(item)}
                >
                  <img src={`${item}`} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inptFileHolder}>
          <label className={Style.lablePart} htmlFor="imgSelect">
            <FontAwesomeIcon icon={faImages} />
          </label>
          <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
          <input
            className={Style.fileInputPart}
            type="file"
            id={"imgSelect"}
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
        </div>
        <Select
          onChange={(e) => getCategory1OnChange(e)}
          options={categoryFirst}
          value={categoryFirst.filter((option) => option.value === categoryId)}
          className={Style.selectOptionsearch}
          placeholder={"دسته بندی اول"}
        />
        <Select
          onChange={(e) => getCategory2OnChange(e)}
          options={categorySecond}
          value={categorySecond.filter(
            (option) => option.value === category2Id
          )}
          className={Style.selectOptionsearch}
          placeholder={"دسته بندی دوم"}
          isDisabled={disableCategorySecond}
        />
        <Select
          onChange={(e) => getBrandOnChange(e)}
          options={brandOption}
          value={brandOption.filter((option) => option.value === brandPersian)}
          className={Style.selectOptionsearch}
          placeholder={"برند محصول"}
        />
        <input
          {...register("product", { required: true })}
          className={errors.product ? Style.errorInput : Style.fileInputPart2}
          placeholder={"عنوان محصول"}
          type="text"
        />
        <input
          {...register("volume")}
          className={Style.fileInputPart2}
          placeholder={"حجم به میلی لیتر"}
          type="text"
        />
        <input
          {...register("weight")}
          className={Style.fileInputPart2}
          placeholder={"وزن به گرم"}
          type="text"
        />
        <input
          {...register("barcode1")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره یک"}
        />

        <input
          {...register("barcode2")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره دو"}
          type="text"
        />
        <input
          {...register("barcode3")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره سه"}
          type="text"
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button disabled={disable} className={Style.btnStyle} type={"submit"}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default SupermarketProductContainer;
